declare namespace $ {

	export class $mol_icon_cube_scan extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=scan.view.tree.d.ts.map